export default __webpack_public_path__ + "static/media/Physique-chimie.b804baa0.png";